import RootLayout from "./layout";
import dashboardRoute from "../dashboard";
import setupRoute from "../setup";
import reportsRoute from "../reports";
import qualityRoute from "../quality"
import staff_and_plant_Route from "../staff_and_plant"
import settingsRoute from "../settings";

const rootRoutes = {
  path: "/", 
  element: <RootLayout />,
  children: [
    ...dashboardRoute,
    ...setupRoute,
    ...reportsRoute,
    ...qualityRoute,
    ...staff_and_plant_Route,
    ...settingsRoute,
  ],
};

export default rootRoutes;